module.exports = __webpack_public_path__ + "img/home-miniapp.be4e229.png";